<div class="container-fluid">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a>Client</a></li>
          <li class="breadcrumb-item active" aria-current="page">Aproval Status</li>
        </ol>
    </nav>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <form [formGroup]="ApprovalStatusForm" style="margin: 10px;">
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="">Approval Status</label>
                            <input type="text" class="form-control" formControlName="approval_name">
                        </div>
                        <!-- <div class="form-group col-md-4">
                            <label for="">Bank Name</label>
                            <ng-select [multiple]="true" formControlName="bank_id">
                                <ng-option *ngFor="let item of banknameList" [value]="item.y" >{{item.y}}</ng-option>
                            </ng-select>
                        </div> -->
                        <div class="form-group col-md-4" >
                            <label for="">Status</label>
                            <select formControlName="status" class="form-control">
                                <option value="">Choose</option>
                                <option value="true">Active</option>
                                <option value="false">In active</option>
                            </select>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-sm btn-success mr-1" (click)="addapprovalStatus()" *ngIf="addmode">ADD</button>
                        <button class="btn btn-sm btn-dark mr-1" (click)="editapprovalStatus()" *ngIf="addmode">EDIT</button>
                        <button class="btn btn-sm btn-info mr-1" (click)="updateapprovalStatus()" *ngIf="editmode">UPDATE</button>
                        <button class="btn btn-sm btn-primary mr-1" (click)="cancel()" *ngIf="editmode">Cancel</button>
                        <button class="btn btn-sm btn-danger mr-1" (click)="deleteapprovalStatus()">DELETE</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <ag-grid-angular #agGrid 
                style="width: auto; height: 500px;"
                class="ag-theme-alpine"
                [rowData]="ApprovalStatusList"
                [rowSelection]="'multiple'"
                [columnDefs]="ApprovalStatuscolumnDefs"
                [pagination]="true">
            </ag-grid-angular>
        </div>
    </div>
</div>
